import i18next from 'i18next'

import menuEn from 'views/panels/admin-panel/HospitalLayout/locales/menu.en.json'
import menuTh from 'views/panels/admin-panel/HospitalLayout/locales/menu.th.json'

/**
 * The page's translation namespace. Its copy ships with the code, like the
 * Device Gateway's: this page adds no translation rows to the database.
 */
export const HOSPITAL_LAYOUT_NS = 'hospital-layout'

/** The menu entry's title, resolved by NavItem's `t()` from this namespace. */
export const HOSPITAL_LAYOUT_MENU_TITLE_KEY = `${HOSPITAL_LAYOUT_NS}:menu.title`

/** Only what the menu shows; it is in the main chunk. */
export const HOSPITAL_LAYOUT_MENU_BUNDLES = { en: menuEn, th: menuTh }

/** Adds bundles to the namespace; waits for init() when not yet ready. */
export const registerHospitalLayoutBundles = (bundles, i18n = i18next) => {
  const register = () =>
    Object.entries(bundles).forEach(([language, bundle]) => {
      i18n.addResourceBundle(language, HOSPITAL_LAYOUT_NS, bundle, true, false)
    })
  if (typeof i18n.addResourceBundle === 'function') register()
  else i18n.on('initialized', register)
}

registerHospitalLayoutBundles(HOSPITAL_LAYOUT_MENU_BUNDLES)
